export default __webpack_public_path__ + "static/media/NotFound.5f967f63.png";